import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import './PrintFunction.css'

import compassImg from './.image/compass.png'

export class PrintFunction extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            drawLatLon: true,
            drawCompass: true,
        }
    }

    componentDidMount() {
        this.ratio = 287 / 200;    //A4橫向寬高297mm:210mm減掉margin:左右各1cm
        this.PrintStyle = document.createElement('style');
        window.document.head.appendChild(this.PrintStyle);


    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="列印功能"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow}  />
        );
    }

    content() {
        return (
            <div className='printFunction'>
                <div>
                    <label className="checkbox-container label">
                        顯示經緯度
                        <input type="checkbox" id="Print-DrawLatLon" checked={this.state.drawLatLon} onChange={(e) => { e.persist(); this.setState({ drawLatLon: !this.state.drawLatLon }) }} />
                        <span className="checkmark">
                        </span>
                    </label>
                    <label className="checkbox-container label">
                        顯示指北針
                        <input type="checkbox" id="Print-DrawLatLon" checked={this.state.drawCompass} onChange={(e) => { e.persist();this.setState({ drawCompass: !this.state.drawCompass }) }} />
                        <span className="checkmark">
                        </span>
                    </label>
                </div>
                <button className="printFunction-btn" onClick={() => { this.PrintScreen(); }}>下一步</button>
            </div>
        );
    }

    PrintScreen() {
        var mapview = "";
        var page = "";

        var width = window.innerWidth * 0.4;
        var height = window.innerHeight * 0.4;

        var windowRatio = width / height;
        let ratio = this.ratio;

        if (windowRatio > this.ratio) {
            ratio = 277 / width;
            height = height * ratio;
            var margin = (210 - height) / 2;
            mapview += "height:" + height + "mm;width: 277mm;";
            page += "margin-top:" + margin + "mm; size: A4 landscape;";
        }
        else if (windowRatio < this.ratio && windowRatio > 1) {
            ratio = 190 / height;
            width = width * ratio;
            var margin = (297 - width) / 2;
            mapview += "width:" + width + "mm;height: 180mm;";
            page += "margin-left:" + margin + "mm; size: A4 landscape;";
        }
        else if (windowRatio < 1 && windowRatio > (200 / 287)) {
            ratio = 190 / width;
            height = height * ratio;
            var margin = (297 - height) / 2;
            mapview += "height:" + height + "mm;width: 190mm;";
            page += "margin-top:" + margin + "mm; size: A4 portrait;";
        }
        else {
            ratio = 277 / height;
            width = width * ratio;
            var margin = (210 - width) / 2;
            mapview += "width:" + width + "mm;height: 277mm;";
            page += "margin-left:" + margin + "mm; size: A4 portrait;";
        }

        this.PrintStyle.innerHTML = "@media print { .noPrint {display:none;}";

        if (this.state.drawLatLon) {
            var statusbar = document.createElement("span");
            statusbar.id = "statusbar";

            statusbar.innerHTML = "【座標:" + document.getElementById("x_coordinates").innerHTML;
            statusbar.innerHTML += document.getElementById("y_coordinates").innerHTML;
            statusbar.innerHTML += document.getElementById("h_coordinates").innerHTML;
            document.getElementsByTagName('body')[0].append(statusbar);
            var statusbar = "color:black;background-color:transparent;position:absolute;bottom:0;left:0;";
            this.PrintStyle.innerHTML += "#statusbar {" + statusbar + "}";
        }

        let settings = this.ResizeLegendToolToFitPrint(ratio);
        if (this.state.drawCompass) {
            var compass = document.createElement("img");
            compass.src = compassImg;
            compass.id = "compass";
            document.getElementsByTagName('body')[0].append(compass);
            var point = new window.GeoPoint(window.gMainMap.TerrainView.camera.v.x, window.gMainMap.TerrainView.camera.v.y);

            if (window.gMainMap.TerrainView.camera.v.y == 0 && window.gMainMap.TerrainView.camera.v.x == 0) {
                angel = 0;
            } else {
                var angel = Math.atan2(window.gMainMap.TerrainView.camera.v.y, window.gMainMap.TerrainView.camera.v.x);
                angel = angel * 180 / Math.PI;
                angel -= 90;    //配合css, transform: ratate
            }
            if (angel < 0)
                angel += 360;

            var compassStyle = ' width:64px;height:64px;z-index:9999;position:absolute;top:0;right:-10;';
            compassStyle += '-ms-transform: rotate(' + angel + 'deg);-webkit-transform: rotate(' + angel + 'deg);transform: rotate(' + angel + 'deg);';
            compass.onload = function () {
                this.PrintStyle.innerHTML += "#compass{" + compassStyle + "}#MainMap{" + mapview + "}}@page{" + page + "}";
                window.print();
                compass.remove();
                if (this.state.drawLatLon) {
                    var statusbar = document.getElementById("statusbar");
                    statusbar.remove();
                }
                setTimeout(this.RestoreLegendToolSize, 0, settings);
            }.bind(this);
        }
        else {
            this.PrintStyle.innerHTML += "#MainMap{" + mapview + "}} @page{" + page + "}";
            window.print();
            if (this.state.drawLatLon) {
                var statusbar = document.getElementById("statusbar");
                statusbar.remove();
            }
            setTimeout(this.RestoreLegendToolSize, 0, settings);
        }


        //window.print();
    }

    ResizeLegendToolToFitPrint(ratio) {
        let rtn = [];
        let containers = document.getElementsByClassName('legend-container');
        //containers.classList.add('legend-container');

        for (let i = 0; i < containers.length; i++) {
            let container = containers[i];
            rtn[i] = {};
            rtn[i].left = container.style.left;
            rtn[i].top = container.style.top;
            rtn[i].width = container.style.width;
            rtn[i].height = container.style.height;

            let resizedleft = parseFloat(container.style.left.slice(0, container.style.left.length - 2)) * ratio;
            let resizedtop = parseFloat(container.style.top.slice(0, container.style.top.length - 2)) * ratio;
            let resizedWidth = parseFloat(container.style.width.slice(0, container.style.width.length - 2)) * ratio;
            let resizedHeight = parseFloat(container.style.height.slice(0, container.style.height.length - 2)) * ratio;

            container.style.left = resizedleft + "px";
            container.style.top = resizedtop + "px";
            container.style.width = resizedWidth + "px";
            container.style.height = resizedHeight + "px";
        }

        return rtn;
    }

    RestoreLegendToolSize(settings) {
        let containers = document.getElementsByClassName('legend-container');

        for (let i = 0; i < settings.length; i++) {
            let container = containers[i];
            container.style.left = settings[i].left;
            container.style.top = settings[i].top;
            container.style.width = settings[i].width;
            container.style.height = settings[i].height;
        }
    }

    //縮小視窗 暫用不到
    minimizeWindow = () => {
        this.state
            .draggableWindowContext
            .printFunction
            .update({
                isOpened: false,
            });
    }
}